const assets = import.meta.glob('/src/assets/**/*', {
  eager: true,
  query: '?url',
  import: 'default'
}) as Record<string, string>;

export function asset(relPath: string): string {
  let key: string;
  if (relPath.startsWith('@/')) {
    key = '/src/' + relPath.slice(2);
  } else if (relPath.startsWith('/src/')) {
    key = relPath;
  } else if (relPath.startsWith('src/')) {
    key = '/' + relPath;
  } else {
    key = '/src/assets/' + relPath.replace(/^assets\//, '');
  }
  return assets[key] || relPath;
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $asset: typeof asset;
  }
}
